export function getFullDateYearsAgo(date: Date, years: number) {
  const year = date.getFullYear() - years;
  const monthCorrection = date.getMonth() + 1;
  const month = monthCorrection < 10 ? '0' + monthCorrection : monthCorrection;
  return year + '-' + month + '-' + date.getDate();
}
